export default {"src":"/_next/static/media/android_logo.949c02d0.svg","height":42,"width":34,"blurWidth":0,"blurHeight":0};